package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.percent

@Composable
fun VerifySignInCode(
    mfaCode: String,
    info: String,
    infoHeader: String,
    loading: Boolean,
    onMFACodeChange: (String) -> Unit,
    onSubmitClick: () -> Unit,
    onCancelClick:()->Unit,
)
{
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SpanText(
            text = infoHeader,
            modifier = Modifier
                .margin(top= Dimen.largePadding)
                .color(Theme.TextSecondary.rgb)
                .textAlign(TextAlign.Center)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.SemiBold)
                .fontSize(FontSizes.largeFontSize)
                .lineHeight(100.percent)
        )
        SpanText(
            text = info,
            modifier = Modifier
                .margin(top= Dimen.largePadding)
                .color(Theme.TextSecondary.rgb)
                .textAlign(TextAlign.Center)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Normal)
                .fontSize(FontSizes.mediumFontSize)
                .lineHeight(100.percent)
        )

        Spacer()

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().mfaCode,
            value = mfaCode,
            isRequired = false,
            isDecimal = true,
            hint ="",
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                onMFACodeChange(it)
            },
        )



        LoginSubmitButton(
            tvTitle = Strings.current().cancel,
            buttonTitle = Strings.current().submit,
            loading = loading,
            isClickable = mfaCode.length==Constants.MFA_LENGTH,
            onButtonClick ={
                onSubmitClick()
            },
            onTitleClick = {
                onCancelClick()
            }
        )


    }



}